<template>
	<fragment v-if="!itemConfig.multiple">
		<slot></slot>
	</fragment>
	<fragment v-else-if="itemConfig.type === 'L' && itemConfig.multiple">
		<slot></slot>
	</fragment>
	<fragment v-else-if="itemConfig.multiple">
		<div class="multiple-attribute" :id="attributeName + '__area'" :max-count="itemConfig.maxCount">
			<div class="col-sm-5">
				<label :id="attributeName + '_label'"
					   :for="attributeName + '__0'"
					   :data-description="$t(itemConfig.title)"
					   :title="$t(itemConfig.title)">
					<span v-if="enableCopyAttributeName" class="fa fa-files-o label-copy-icon"
						  v-bind-copy-to-clipboard="attributeName"/>
					<span v-if="requiredLabelIcon" :class="requiredLabelIcon"/>
					<span v-if="requiredPrimaryIcon" :class="requiredPrimaryIcon"/>
					<i v-if="lockedEdit" class="fa fa-lock"/>

					<label-tooltip :label="$t(itemConfig.title)"/>
					<button v-if="!lockedEdit" class="button_plus fa fa-plus" tabindex="-1" @click="createAttr(attributeName)"/>
				</label>
			</div>
			<slot></slot>
		</div>
	</fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { copyComponent } from '@/core/item_assistance/creatingNewComponents'
import { attributeLabel } from '@/mixins/attributeLabel'
import LabelTooltip from 'components/item-edit/partials/LabelTooltip'

export default {
	name: 'AttributeWrapperForEditableComponent',
	props: [
		'itemConfig',
		'attributeName',
		'isPrimary',
		'enableCopyAttributeName',
		'itemData',
		'lockedEdit'
	],
	mixins: [
		attributeLabel
	],
	components: {
		Fragment,
		LabelTooltip
	},
	directives: {
		bindCopyComponent: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'copyComponent(\'' + binding.value + '\', false, true);')
			}
		},
		bindCopyToClipboard: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'CopyToClipboard(\'{' + binding.value + '}\')')
			}
		}
	},
	methods: {
		createAttr: function (name) {
			if (this.itemData) {
				let prevValue = this.itemData[name] ? this.itemData[name]: [""]
				if (this.itemConfig.maxCount === -1) {
					if (this.itemConfig.type === 'NM') {
						prevValue.push({
							val: '',
							mu: this.itemConfig.defaultValue.mu
						})
					} else if (this.itemConfig.type === 'A') {
						return
					} else {
						prevValue.push("")
					}
					this.$set(this.itemData, name, prevValue)
				}
			} else {
				copyComponent(name, false, true)
			}
		}
	}
}
</script>

<style scoped>

</style>
